import React from "react"
import styled from "styled-components"

const IframeWrap = styled.div`
  height: 550px;
  width: 1000px;
  margin-top: 100px;

  @media screen and (max-height: 1000px), (max-width: 1300px) {
    height: 500px;
    width: 900px;
    margin-top: 0px;
  }

  @media screen and (max-height: 900px), (max-width: 1200px) {
    height: 450px;
    width: 800px;
  }

  @media screen and (max-height: 800px), (max-width: 1100px) {
    height: 400px;
    width: 700px;
  }

  @media screen and (max-width: 1000px) {
    height: 400px;
    width: 600px;
  }

  @media screen and (max-width: 900px) {
    height: 400px;
    width: 500px;
  }

  @media screen and (max-width: 800px) {
    height: 300px;
    width: 400px;
  }
`

export const Youtube = url => {
  console.log("url", url)
  return (
    <IframeWrap>
      <iframe
        width="85%"
        height="100%"
        src={url.url}
        title="YouTube video player"
        frameBorder="0"
        style={{ borderRadius: 20 }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        // allowfullscreen
      ></iframe>
    </IframeWrap>
  )
}
